import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

/*

import { CredoAppServiceAsync } from "@credolab/credoapp-sdk";

// CredoApp authentication key provided by credolab team
var authKey = "74fd0097-e53e-4784-90af-703252dc0ff2"
// value from CredoLab URLs table
var url = "https://scoring-demo.credolab.com";
// reference number intended to associate the collected dataset with the lender's record 
//var referenceNumber = "0757e4fe654712e11d591c41fb9c08de";
var referenceNumber = "0557e4fe654712e11d591c41fb9c08de";
// init CredoAppService
var credoAppService = new CredoAppServiceAsync(url, authKey);

credoAppService.startTrackingAsync(referenceNumber).then(() => {
  alert("Event tracking started and dataset continuously uploaded");
}, (e) => alert(e));

setTimeout(() => {
  stopTracking();
},2000)

function stopTracking() {
  credoAppService.stopTrackingAsync().then(() => {
    alert("Event tracking stopped");
  }, (e) => alert(e));
}

function collectData() {
  credoAppService.stopTrackingAndCompleteAsync().then(() => {
    alert("Dataset has been completed");
  }, (e) => alert(e));
}
*/
if (environment.production) {
 // enableProdMode();
//  window.console.log = () => {}
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
